"use client";

import React from "react";
import { useRouter } from "next/navigation";

import { Path, PATHS } from "@/internals/constants/paths";

export const usePrefetchRouter = (routesToPrefetch: Path[]) => {
  const router = useRouter();

  React.useEffect(() => {
    const essentialRoutes = [PATHS.HOME, PATHS.LOGIN, PATHS.SIGNUP, PATHS.PRICING, PATHS.PAYMENT];

    const allRoutes = [...new Set([...essentialRoutes, ...routesToPrefetch])];

    allRoutes.forEach((route) => {
      router.prefetch(route);
    });
  }, []);
};
